import * as React from "react";
import { getTheme } from "@warda/library-ui/theme";
import CircularProgress from "@warda/library-ui/core/CircularProgress";
const Spinner = ({ value }) => (React.createElement(CircularProgress, { variant: value ? "determinate" : "indeterminate", value: value, size: 16, color: getTheme().colors.msgInfo, style: { padding: "0 8px" } }));
export default Spinner;
